
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    
import style from '../../styles/content.module.css'

import { getLayout, LayoutContext } from '../../components/sg/Layout'
import Header from '../../components/Header'
import useTranslation from 'next-translate/useTranslation'
import classNames from 'classnames/bind'
import Link from 'next/link'
import Image from 'next/image'
import { useLivePrice } from '../../hooks/usePrices'
import resolveProductUnit from '../../helpers/resolveProductUnit'
import Footer from '../../components/sg/Footer'
import Cards from '../../components/sg/Cards'
import Head from 'next/head'
import { useRouter } from 'next/router'
import { useContext } from 'react'
export default function FAQ () {
  const { t } = useTranslation('main')
  const c = classNames.bind(style)
  const router = useRouter()
  const { locale } = router
  const [layoutContext] = useContext(LayoutContext)
  const { currency } = layoutContext
  const { productPriceResolution } = resolveProductUnit('gram', 1)
  const { price: { value: spotPrice } } = useLivePrice(currency, 'gld', productPriceResolution)
  // const { gld: gldPremium, sil: silPremium, plt: pltPremium } = usePremiums(currency, locale)
  return (
    <>
      <Head>
        <title>{t('faq-pagetitle')}</title>
        <meta property='og:title' key='og:title' content={t('faq-title')} />
        <meta property='og:url' key='og:url' content={router?.pathname} />
        <meta property='og:description' key='og:description' content={t('faq-pagedescription')} />
        <meta property='og:type' key='og:type' content='article' />
        <meta property='og:site_name' key='og:site_name' content={t('faq-sitename')} />
        <meta name='title' key='title' content={t('faq-title')} />
        <meta name='description' key='description' content={t('faq-pagedescription')} />
      </Head>
      <Header showLogo />
      <div className={c('content')}>
        <div className={c('hero')}>
          <Image src='/images/goldbars.jpg' layout='fill' className={c('wide')} alt='Photo of gold bars' />
        </div>
        <div className={c('inner')}>
          <div className={c('single')} data-meh={spotPrice + locale}>
            <h3>{t('faq-title')}</h3>

            <h4>{t('faq-spread-question')}</h4>
            <p>{t('faq-spread-answer', { goldPremium: '2.00%', silverPremium: '4.00%', platinumPremium: '3.50%' })}</p>
            <p>{t('faq-spread-answer-disclaimer')}</p>

            <h4>{t('faq-withdrawaltime-question')}</h4>
            <p>{t('faq-withdrawaltime-answer')}</p>

            <h4>{t('faq-bankinfo-question')}</h4>
            <p>{t('faq-bankinfo-answer')}</p>

            <h4>{t('faq-interest-question')}</h4>
            <p>{t('faq-interest-answer')}</p>

            <h4>{t('faq-minimumduration-question')}</h4>
            <p>{t('faq-minimumduration-answer')}</p>

            <h4>{t('faq-redemptionpremium-question')}</h4>
            <p>{t('faq-redemptionpremium-answer')}</p>

            <h4>{t('faq-redemptionproducts-question')}</h4>
            <p>{t('faq-redemptionproducts-answer')}</p>

            <h4>{t('faq-updatebankinfo-question')}</h4>
            <p>{t('faq-updatebankinfo-answer')}</p>

            <h4>{t('faq-closeaccount-question')}</h4>
            <p>{t('faq-closeaccount-answer')}</p>

          </div>
          <div className={c('promotion')}>
            {t('banner-mission-1')}<br />
            {t('banner-mission-2')}<br />
            <br />
            <br />
            <Link href='/signup'>
              <button className='goldenshimmer' title={t('banner-signup-button-title')}>{t('banner-signup-button')}</button>
            </Link>
            <span className={c('termsnote')}>{t('banner-signup-subtext')}</span>
          </div>
        </div>
      </div>
      <Cards />
      <Footer />
    </>
  )
}

FAQ.getLayout = getLayout


    export async function getStaticProps(ctx) {
        
        
        return {
          
          
          props: {
            
            ...(await __loadNamespaces({
              ...ctx,
              pathname: '/sg/faq',
              loaderName: 'getStaticProps',
              ...__i18nConfig,
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
            }))
          }
        }
    }
  